/** @format */

'use strict';

angular.module('emsApp').config(function($stateProvider) {
	/**
	 * Add all translations for a 'EventRelationContact'
	 */
	var getTranslations = function($translate, $translatePartialLoader) {
		$translatePartialLoader.addPart('eventrelationcontact'); // main translation loaded for eventrelationcontact
		$translatePartialLoader.addPart('salesstatus'); // one to many reference from main entity
		$translatePartialLoader.addPart('event'); // one to many reference from main entity
		$translatePartialLoader.addPart('relation'); // one to many reference from main entity
		$translatePartialLoader.addPart('relationtype'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('relationsource'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('gender'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('clientof'); // one to one or many to one reference from main entity
		$translatePartialLoader.addPart('langkey'); // one to one or many to one reference from main entity

		return $translate.refresh();
	};

	/**
	 * "private" function called by wrapper new and edit functions.
	 */
	var getModalState = function(url, isEditMode) {
		if (!angular.isDefined(url) || url === null) {
			url = '/new';
		}

		if (!angular.isDefined(isEditMode) || isEditMode === null) {
			// default mode is NEW, however this situation should and will be avoided by as this function should only be
			isEditMode = false;
		}

		var templateUrl;
		// The default assignment to templateUrl can be overridden in hook custom/jhipster/state/template_url/add_or_edit.ftl
		templateUrl = 'app/entities/eventrelationcontact/eventrelationcontact-dialog.html';

		return {
			/* new state for entity eventRelationContact */
			/* to access: ui-ref="eventrelationcontact.list.new" */
			/* url: hostname/eventrelationcontact/new */
			url: url,
			data: {
				authorities: ['ROLE_USER'],
				isModal: true,
			},
			params: {
				mappedBy: null,
				mappedByType: null,
				mappedById: null,
				dataModel: null, // this data model is set from the new relation state OR from the save and new logic
				mappedByDisplayValue: null,
				dataModelType: null, // this data model type is the name of the modelobject, lowercase

				hiddenParam: 'YES', // hides params from url
			},
			onEnter: [
				'$stateParams',
				'$state',
				'$uibModal',
				'$rootScope',
				function($stateParams, $state, $uibModal, $rootScope) {
					var navigateBack = true;

					$uibModal
						.open({
							templateUrl: templateUrl,
							controller: 'EventRelationContactDialogController',
							size: 'lg',
							backdrop: 'static',
							resolve: {
								entity: [
									'EventRelationContactFactory',
									'NewEventRelationContactFactory',
									function(EventRelationContactFactory, NewEventRelationContactFactory) {
										// NOTE either this dialog was opened with the purpose of
										// - creating a new EventRelationContact
										// - resuming the creation of a new new EventRelationContact AFTER new instances were created of x..1 reference(s)

										// if dataModel is defined, we're coming back from a new created x..1 reference
										if ($rootScope.isDefinedAndNotNull($stateParams.dataModel)) {
											var model = $stateParams.dataModel;
											// reset 'remembered' values to prevent future misbehaviour
											$rootScope.previousStateParams.dataModel = null;
											$stateParams.dataModel = null;

											// instead of returning a new model, we return the updated model
											return model;
										} else {
											if (isEditMode) {
												// get the entity by its ID
												return EventRelationContactFactory.get({ id: $stateParams.eventRelationContactId }).$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											} else {
												// get a new empty entity
												return NewEventRelationContactFactory.get().$promise.then(
													function(data) {
														return data;
													},
													function(error) {
														return error;
													}
												);
											}
										}
									},
								],
								translatePartialLoader: [
									'$translate',
									'$translatePartialLoader',
									function($translate, $translatePartialLoader) {
										return getTranslations($translate, $translatePartialLoader);
									},
								],
							},
						})
						.result.then(function() {
							// process success result, if necessary
						})
						.catch(function(closeReason) {
							if (closeReason === 'createNew') {
								// only navigate back in history if the close reason allows us to
								navigateBack = false;
							}
						})
						.finally(function() {
							if (navigateBack) {
								$rootScope.back();
							}
						});
				},
			],
		};
	};

	/**
	 * Body for eventRelationContact new state
	 */
	function getNewState(url) {
		return getModalState(url, false);
	}

	/**
	 * Body for eventRelationContact edit state
	 */
	function getEditState(url) {
		return getModalState(url, true);
	}

	$stateProvider.state('eventrelationcontact', {
		/* abstract state for entity eventRelationContact */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/eventrelationcontact',
		data: {
			authorities: ['ROLE_USER'],
			pageTitle: 'EventRelationContacts',
			isModal: false,
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	$stateProvider.state('eventrelationcontact.list', {
		/* list state for entity eventRelationContact */
		/* to access: ui-ref="eventrelationcontact.list" */
		/* url: hostname/eventrelationcontact/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/eventrelationcontact/eventrelationcontacts.html',
				controller: 'EventRelationContactController',
			},
		},
	});

	$stateProvider.state('eventrelationcontact.detail', {
		/* detail state for entity eventRelationContact */
		/* to access: ui-sref="eventrelationcontact.detail" */
		/* url: hostname/eventrelationcontact/detail/:eventRelationContactId */
		url: '/detail/:eventRelationContactId',
		views: {
			'content@': {
				templateUrl: 'app/entities/eventrelationcontact/eventrelationcontact-detail.html',
				controller: 'EventRelationContactDetailController',
			},
		},
		resolve: {
			entity: [
				'$stateParams',
				'EventRelationContactFactory',
				function($stateParams, EventRelationContactFactory) {
					return EventRelationContactFactory.get({ id: $stateParams.eventRelationContactId });
				},
			],
		},
	});

	/* url: http://<hostname>/eventrelationcontact/list/new */
	$stateProvider.state('eventrelationcontact.list.new', getNewState());
	/* url: http://<hostname>/eventrelationcontact/list/:eventRelationContactId/edit */
	$stateProvider.state('eventrelationcontact.list.edit', getEditState('/:eventRelationContactId/edit'));
	/* url: http://<hostname>/eventrelationcontact/detail/:eventRelationContactId/edit */
	$stateProvider.state('eventrelationcontact.detail.edit', getEditState('/edit'));
	// Relation.eventRelationContact with multiplicity 0..n points to EventRelationContact
	/* url: http://<hostname>/relation/detail/:relationId/eventrelationcontact/new */
	$stateProvider.state('relation.detail.newEventRelationContact', getNewState('/eventrelationcontact/new'));
	/* url: http://<hostname>/relation/detail/:relationId/eventrelationcontact/:eventRelationContactId/edit */
	$stateProvider.state('relation.detail.editEventRelationContact', getEditState('/eventrelationcontact/:eventRelationContactId/edit'));
	// Rare case of mixing non-dto's on a dto screen
	/* url: http://<hostname>/user-relation/detail/:relationId/eventrelationcontact/new */
	$stateProvider.state('user-relation.detail.newEventRelationContact', getNewState('/eventrelationcontact/new'));
	/* url: http://<hostname>/user-relation/detail/:relationId/eventrelationcontact/:eventRelationContactId/edit */
	$stateProvider.state('user-relation.detail.editEventRelationContact', getEditState('/eventrelationcontact/:eventRelationContactId/edit'));
	// Event.eventRelationContact with multiplicity 0..n points to EventRelationContact
	/* url: http://<hostname>/event/detail/:eventId/eventrelationcontact/new */
	$stateProvider.state('event.detail.newEventRelationContact', getNewState('/eventrelationcontact/new'));
	/* url: http://<hostname>/event/detail/:eventId/eventrelationcontact/:eventRelationContactId/edit */
	$stateProvider.state('event.detail.editEventRelationContact', getEditState('/eventrelationcontact/:eventRelationContactId/edit'));

	$stateProvider.state('user-eventrelationcontact', {
		/* abstract state for DTO UserEventRelationContactListDto */
		/* NOTE this state cannot be accessed directly, it must be inherited by a nested state by postpending the state name with a new state */
		abstract: true,
		parent: 'entity',
		url: '/user/eventrelationcontact',
		data: {
			authorities: ['ROLE_USER', 'ROLE_ADMIN'],
			pageTitle: 'EventRelationContact',
			isModal: false,
		},
		params: {
			mappedBy: null,
			mappedByType: null,
			mappedById: null,
			dataModel: null, // this data model is set from the new relation state OR from the save and new logic
			mappedByDisplayValue: null,
			dataModelType: null, // this data model type is the name of the modelobject, lowercase

			hiddenParam: 'YES', // hides params from url
		},
		resolve: {
			translatePartialLoader: [
				'$translate',
				'$translatePartialLoader',
				function($translate, $translatePartialLoader) {
					return getTranslations($translate, $translatePartialLoader);
				},
			],
		},
	});

	/* list state for DTO user */
	var dtoListState = {
		/* list state for DTO UserEventRelationContactListDto */
		/* to access: ui-ref="user-eventrelationcontact.list" */
		/* url: http://<hostname>/user/eventrelationcontact/list */
		url: '/list',
		views: {
			'content@': {
				templateUrl: 'app/entities/eventrelationcontact/eventrelationcontact-list-user.html',
				controller: 'UserEventRelationContactListDtoController',
			},
		},
	};

	$stateProvider.state('user-eventrelationcontact.list', dtoListState);
});
